import { atom } from 'jotai';

export const isSpotlightOpenAtom = atom(false);
